<app-pcbread-crumb [data]="'Reports,SaleReport'"></app-pcbread-crumb>
<app-sale-table [endPoint]="'SaleFactorReport'" [title]="'SaleReport'"></app-sale-table>